import request from '@/utils/request'

// 更新用户活跃度
export function getUpdateLastTime(data) {
	return request({
		url:'/app-api/member/user/update-lastTime',
		method: 'get',
		params: data
	})
}


// 名校风采
export function getBannerList(data) {
	return request({
		url:'/app-api/biz/home/get-banner-page',
		method: 'get',
		params: data
	})
}

// 首页信息
export function getHome(data) {
	return request({
		url:'/app-api/biz/home/index',
		method: 'get',
		params: data
	})
}
// 网站常规信息
export function getInfo(data) {
	return request({
		url:'/app-api/biz/home/get-website',
		method: 'get',
		params: data
	})
}
// 名校风采
export function getSwiperList(data) {
	return request({
		url:'/app-api/biz/home/get-eliteSchool-page',
		method: 'get',
		params: data
	})
}
// 获得用户基本信息
export function getUser(data) {
	return request({
		url:'/app-api/member/user/get',
		method: 'get',
		params: data
	})
}

// 获得用户会员
export function getMyLevel(data) {
	return request({
		url:'/app-api/biz/my/my-level',
		method: 'get',
		params: data
	})
}

// 获得轮播图详情
export function getBanner(data) {
	return request({
		url:'/app-api/biz/home/get-banner',
		method: 'get',
		params: data
	})
}
// 修改用户基本信息
export function getUpdateUser(data) {
	return request({
		url:'/app-api/member/user/update',
		method: 'put',
		data
	})
}
// 修改用户联系手机
export function getUpdateMobile(data) {
	return request({
		url:'/app-api/member/user/update-user-mobile',
		method: 'put',
		data
	})
}
// 退出登录
export function getLogout(data) {
	return request({
		url:'/app-api/member/auth/logout',
		method: 'post',
		params: data
	})
}
// 获得搜索记录分页
export function getSearchRecordPage(data) {
	return request({
		url:'/app-api/biz/home/getSearchRecordPage',
		method: 'get',
		params: data
	})
}
// 获得热门搜索分页
export function getHotSearch(data) {
	return request({
		url:'/app-api/biz/home/get-hot-search-page',
		method: 'get',
		params: data
	})
}
// 删除搜索记录
export function getDeleteSearch(data) {
	return request({
		url:'/app-api/biz/home/deleted-search-record',
		method: 'get',
		params: data
	})
}
// 微信一键登录
export function getWxLogin(data) {
	return request({
		url:'/app-api/member/auth/social-login',
		method: 'post',
		data: data
	})
}

// 获得所有类型
export function getSystemType(data) {
	return request({
		url:'/app-api/biz/home/get-system-type',
		method: 'get',
		params: data
	})
}

// 获取验证码
export function sendSmsCode(data) {
	return request({
		url:'/app-api/member/auth/send-sms-code',
		method: 'post',
		data: data
	})
}

// 使用手机 + 验证码登录
export function smsLogin(data) {
	return request({
		url:'/app-api/member/auth/sms-login',
		method: 'post',
		data: data
	})
}

// 使用账号密码登录
export function cipherLogin(data) {
	return request({
		url:'/app-api/member/auth/login',
		method: 'post',
		data: data
	})
}

// 修改用户联系手机
export function updateUserMobile(data) {
	return request({
		url:'/app-api/member/user/update-mobile',
		method: 'put',
		data: data
	})
}